"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenlabsVoiceEnum = void 0;
var ElevenlabsVoiceEnum;
(function (ElevenlabsVoiceEnum) {
    ElevenlabsVoiceEnum["Alice"] = "Xb7hH8MSUJpSbSDYk0k2";
    ElevenlabsVoiceEnum["Aria"] = "9BWtsMINqrJLrRacOk9x";
    ElevenlabsVoiceEnum["Bill"] = "pqHfZKP75CvOlQylNhV4";
    ElevenlabsVoiceEnum["Brian"] = "nPczCjzI2devNBz1zQrb";
    ElevenlabsVoiceEnum["Callum"] = "N2lVS1w4EtoT3dr4eOWO";
    ElevenlabsVoiceEnum["Charlie"] = "IKne3meq5aSn9XLyUdCD";
    ElevenlabsVoiceEnum["Charlotte"] = "XB0fDUnXU5powFXDhCwa";
    ElevenlabsVoiceEnum["Chris"] = "iP95p4xoKVk53GoZ742B";
    ElevenlabsVoiceEnum["Daniel"] = "onwK4e9ZLuTAKqWW03F9";
    ElevenlabsVoiceEnum["Eric"] = "cjVigY5qzO86Huf0OWal";
    ElevenlabsVoiceEnum["George"] = "JBFqnCBsd6RMkjVDRZzb";
    ElevenlabsVoiceEnum["Jessica"] = "cgSgspJ2msm6clMCkdW9";
    ElevenlabsVoiceEnum["Jonas"] = "e6OiUVixGLmvtdn2GJYE";
    ElevenlabsVoiceEnum["Laura"] = "FGY2WhTYpPnrIDTdsKH5";
    ElevenlabsVoiceEnum["Liam"] = "TX3LPaxmHKxFdv7VOQHJ";
    ElevenlabsVoiceEnum["Lily"] = "pFZP5JQG7iQjIQuC4Bku";
    ElevenlabsVoiceEnum["Matilda"] = "XrExE9yKIg1WjnnlVkGX";
    ElevenlabsVoiceEnum["River"] = "SAz9YHcvj6GT2YYXdXww";
    ElevenlabsVoiceEnum["Roger"] = "CwhRBWXzGAHq8TQ4Fs17";
    ElevenlabsVoiceEnum["Sanna_Hartfield_Sassy_Swedish"] = "ZSHzpa6aUvhjzShiBmYw";
    ElevenlabsVoiceEnum["Sanna_Hartfield_Conversational_Swedish"] = "4xkUqaR9MYOJHoaC1Nak";
    ElevenlabsVoiceEnum["Sanna_Hartfield_Narration_Swedish"] = "aSLKtNoVBZlxQEMsnGL2";
    ElevenlabsVoiceEnum["Sarah"] = "EXAVITQu4vr4xnSDxMaL";
    ElevenlabsVoiceEnum["Will"] = "bIHbv24MWmeRgasZH58o";
})(ElevenlabsVoiceEnum = exports.ElevenlabsVoiceEnum || (exports.ElevenlabsVoiceEnum = {}));
